import React from 'react'
import FinalizationBanner from './FinalizationBanner'
import FinalizationForm from './FinalizationForm'

const Finalization = () => {
  return (
    <div>
      <FinalizationBanner />
      <FinalizationForm />
    </div>
  )
}

export default Finalization